import {
  managersSearchSchema,
  managerViewColumns,
  mapManagersViewQuery,
} from "./ManagersView.default";
import ManagedGridView from "../controls/ManagedGridView";
import { SearchQuery } from "../code/search-query/search-query";
import { getCompanyManagers } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface ManagersViewProps {
  readonly trigger?: string;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
  readonly onAction?: (key: string, record: any) => void;
}

function ManagersView(props: ManagersViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={managerViewColumns}
      schema={managersSearchSchema}
      mapQuery={mapManagersViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getCompanyManagers)}
      actions={[
        {
          key: "view",
          label: "View",
          disabled: !permissions.can("CompanyManagers", "view"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("CompanyManagers", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default ManagersView;
